import {
  Colors,
  Navbar,
  NavbarDivider,
  NavbarGroup,
  NavbarHeading,
  Text,
} from "@blueprintjs/core";
import React from "react";
import { Link } from "react-router-dom";
import Logo from "../images/logo.png";

export default function Navigation() {
  return (
    <Navbar>
      <NavbarGroup>
        <NavbarHeading style={{ padding: "10px" }}>
          <Text class="bp3-text-large">
            <div>
              <img
                src={Logo}
                alt=""
                style={{
                  width: "24px",
                  verticalAlign: "middle",
                  marginRight: "1rem",
                }}
              />
              <span>
                <Link
                  to="/"
                  style={{ color: Colors.BLACK, textDecoration: "none" }}
                >
                  Statistik Data
                </Link>
              </span>
            </div>
          </Text>
        </NavbarHeading>
        <NavbarDivider></NavbarDivider>
      </NavbarGroup>
      {/* <NavbarGroup align={Alignment.RIGHT}>
        <Button className={Classes.MINIMAL} icon="home" text="Trend" />
      </NavbarGroup> */}
    </Navbar>
  );
}
